import { CancelToken } from 'axios';
import { BaseApi } from './BaseApi';

export default class StoreOptions extends BaseApi {
  public async getForStoreAsync(cancelToken?: CancelToken) {
    return this.getListAsync<IStoreOption>('storeoptions', null, cancelToken);
  }
}
